import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-background/95 backdrop-blur-md border-t border-border">
      <Link
        to="/best-high-efficiency-solar-panels"
        className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-accent text-foreground font-heading font-bold text-sm rounded-lg hover:bg-accent/90 transition-colors"
      >
        Compare Solar Panels <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}